module.exports = __webpack_public_path__ + "static/media/DocuWareLogo32px.52340892.svg";